export default __webpack_public_path__ + "static/media/55.ffe19185.jpeg";